// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c7f9515","455":"e89513ff","977":"9700f4af"}[chunkId] + ".chunk.js";
};